import type { KhoaDich } from '../../i18n';
import type { LoiTenPhongBan } from './nghiep-vu/cay';

export const KHOA_LOI_TEN: Record<LoiTenPhongBan, KhoaDich> = {
  trong: 'coCauToChuc.fTenTrong',
  dai: 'coCauToChuc.fTenDai',
};
